import React from "react";

const UserMessage = ({ message }: { message: string }): JSX.Element => (
	<div className="msg-bubble user">{message}</div>
);

export default UserMessage;
